/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suave_Late_Pelican_BaskInputs */

const fr_suave_late_pelican_bask = /** @type {(inputs: Suave_Late_Pelican_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Suave_Late_Pelican_BaskInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const suave_late_pelican_bask = /** @type {((inputs?: Suave_Late_Pelican_BaskInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suave_Late_Pelican_BaskInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_suave_late_pelican_bask(inputs)
});